import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MoreIcon from "@mui/icons-material/MoreVert";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LocalStorage, LoginUserDetails } from "../../util/Utils";
import { useTranslation } from "react-i18next";
import Breadcrumb from "./breadcrumb";
import { ArrowDropDown as ArrowDropDownIcon } from "@mui/icons-material/";
import { notificationAction } from "../../store/notification/notification";
import Toaster from "../../component/Toaster";
import GlobalLoader from "../../component/GlobalLoader";
import RightDrawer from "./RightDrawer";
import NotificationSidebar from "./NotificationSidebar";
import { logout } from "../../auth/login/Auth";
import { CommonService } from "../../store/common/CommonSlice";
import dayjs from "dayjs";
import { countryWiseDateFormate, DateTimeUtil } from "../../util/DateTimeUtils";

export default function ProfileBar() {
  const { t } = useTranslation();
  const buildVersion = process.env.REACT_APP_BUILD_VERSION;
  const buildReleaseDt = process.env.REACT_APP_RELEASE_DATE;
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [notificationCount, setNotificationCount] = React.useState<any>(0);
  const [spinner, setSpinner] = React.useState<any>(false);
  const [notificationDrawer, setNotificationDrawer] =
    React.useState<any>(false);
  const [notificationList, setNotificationList] = React.useState<any>([]);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
    React.useState<null | HTMLElement>(null);

  const handleNotificationOpenClose = () => {
    setNotificationDrawer(!notificationDrawer);
    handleMobileMenuClose();
  };

  const dispatch = useDispatch<any>();
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const dateFormat = process.env.REACT_APP_DEFAULT_DATE_FORMAT;

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };
  const navigate = useNavigate();
  const options = [t("MyProfile"), t("ChangePassword"), t("Logout")];
  const loginUserName: any =
    LoginUserDetails.getUserDetails()?.franchisee?.centerName || "";

  const handleMenuItemClick = (index: number) => {
    if (index === 0) {
      navigate("/my-profile");
    } else if (index === 1) {
      navigate("/change-password");
    } else if (index === 2) {
      logoutAPICall();
      logout();
    }
    setSelectedIndex(index);
    setTimeout(() => {
      handleMenuClose();
    }, 1200);
  };
  const logoutAPICall = () => {
    dispatch(
      CommonService({
        apiAction: "logout",
        common: {
          requestData: LocalStorage.get("user-token"),
        },
      })
    )
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          LocalStorage.remove(undefined, true);
          window.location.href =
            window.location.origin + window.location.pathname;
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {options.map((option, index) => (
        <MenuItem
          // disabled={index === 0 ? true : false}
          className={
            "my-frofile-menu-item " +
            (index !== options.length - 1 ? "my-frofile-menu-item-border" : "")
          }
          key={option}
          selected={index === selectedIndex}
          onClick={() => handleMenuItemClick(index)}
        >
          {option}
        </MenuItem>
      ))}
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <div>
        <div>Version: {buildVersion}</div>
        <div>Release Date: {dayjs(DateTimeUtil.format(buildReleaseDt, dateFormat, true)).format(countryWiseDateFormate())}</div>
      </div>
      <MenuItem onClick={handleNotificationOpenClose}>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Badge badgeContent={notificationCount} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>

      <MenuItem>
        <div className="flag">
          <img
            src="https://cdn.britannica.com/97/1597-004-05816F4E/Flag-India.jpg"
            style={{ width: "36px", height: "24px", marginRight: "5px" }}
            alt="flag-country-without-border"
          />
        </div>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
        <ArrowDropDownIcon className="pointer label-gray" />
      </MenuItem>
    </Menu>
  );

  const getNotificationCount = () => {
    setSpinner(true);
    dispatch(notificationAction({ apiAction: "notificationCount" }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setNotificationCount(result?.payload?.data?.data);
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {})
      .finally(() => {
        setSpinner(false);
      });
  };

  const getNotificationList = () => {
    dispatch(notificationAction({ apiAction: "getNotificationList" }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setNotificationList(
            result?.payload?.data?.data?.sort((a: any, b: any) => b.id - a.id)
          );
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {});
  };

  const acknowledgeNotification = (Nid: any) => {
    dispatch(
      notificationAction({
        apiAction: "acknowledgeNotification",
        formValues: [Nid],
      })
    )
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          getNotificationCount();
          getNotificationList();
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {});
  };

  React.useEffect(() => {
    getNotificationCount();
    getNotificationList();
  }, []);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed">
        <Toolbar>
          <div className="breadcrumb-profilebar">
            <Breadcrumb />
          </div>
          <div className="label-center-name-profilebar">{loginUserName}</div>
          <Box sx={{ flexGrow: 1 }} />

          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <div>
              {/* <div className="build-version label-gray">
                Version: {buildVersion}
              </div> */}

              <div className="build-version label-gray">
                Version: {buildVersion}
              </div>
              <div className="build-version label-gray">
                Release Date: {dayjs(DateTimeUtil.format(buildReleaseDt, dateFormat, true)).format(countryWiseDateFormate())}
              </div>
            </div>
            <IconButton
              onClick={handleNotificationOpenClose}
              size="large"
              aria-label="show 17 new notifications"
              color="inherit"
            >
              <Badge badgeContent={notificationCount} color="error">
                <NotificationsIcon className="label-gray" />
              </Badge>
            </IconButton>
            <IconButton>
              <div className="flag-country-with-border">
                <img
                  src="https://cdn.britannica.com/97/1597-004-05816F4E/Flag-India.jpg"
                  style={{ width: "36px", height: "24px", marginRight: "5px" }}
                  alt="Flag-India"
                />
              </div>
            </IconButton>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle className="label-gray" />
              <ArrowDropDownIcon className="pointer label-gray" />
            </IconButton>
          </Box>
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon className="label-gray" />
            </IconButton>
          </Box>
          <RightDrawer
            open={notificationDrawer}
            onClose={handleNotificationOpenClose}
            title={t("notifications.title")}
            content={
              <NotificationSidebar
                notificationList={notificationList}
                acknowledgeNotification={acknowledgeNotification}
              />
            }
          />
        </Toolbar>
        <GlobalLoader loading={spinner} />
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </Box>
  );
}